export default "__VITE_ASSET__CyoCfLAM__"